import React, { useEffect, useState } from "react";
import { Modal, Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ImpersonationAccessDeniedModal = ({ allowedPaths = [] }) => {
  const navigate = useNavigate();
  const impersonation = useSelector((state) => state.impersonation);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (impersonation?.isImpersonating) {
      const currentPath = window.location.pathname;
      if (allowedPaths.length > 0) {
        if (!allowedPaths.includes(currentPath)) {
          setShowModal(true);
        }
      } else {
        setShowModal(true);
      }
    } else {
      setShowModal(false);
    }
  }, [impersonation?.isImpersonating]);

  const handleGoToPage = () => {
    setShowModal(false);
    if (allowedPaths.length > 0) {
      navigate(allowedPaths[0]);
    }
  };

  return (
    <Modal
      open={showModal}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      width={500}
    >
      <Result
        status="403"
        title="Access Restricted"
        subTitle="You do not have permission to view this page while managing a business."
        extra={
          <Button type="primary" onClick={handleGoToPage}>
            Go to Allowed Page
          </Button>
        }
      />
    </Modal>
  );
};

export default ImpersonationAccessDeniedModal;
